export const projects = [
  {
    image: "/projects/verity.png",
    name: "Verity",
    subtitle:
      "Conversational fact-checking tool that uses AI to verify the accuracy of information in real-time.",
    languages: ["TypeScript", "React", "Next.js", "Flask", "LangChain"],
    githubLink: "https://github.com/0xcolinhenderson/cruzhacks2025",
  },
  {
    image: "/projects/repotoresume.jpg",
    name: "RepoToResume",
    subtitle:
      "Generates a stylized resume card from a public GitHub repository!",
    languages: ["JavaScript", "React", "Next.js", "Tailwind CSS"],
    webLink: "https://repotoresu.me",
    githubLink: "https://github.com/charlesphu/SpeedFill/",
  },
  {
    image: "/projects/speedfill.jpg",
    name: "SpeedFill",
    subtitle:
      "Match your resume to a job description, or automate cover letter generation in just a few clicks.",
    languages: ["JavaScript", "Material-UI", "React", "Next.js"],
    webLink: "https://speed-fill.vercel.app",
    githubLink: "https://github.com/charlesphu/SpeedFill/",
  },
  {
    image: "/projects/dermascan.jpg",
    name: "DermaScan",
    subtitle:
      "Leveraging machine learning to detect different kinds of acne, and provide tailored treatment options. Took home a hackathon prize for this one!",
    languages: ["Python", "Flask", "Bootstrap 5", "PyTorch"],
    githubLink: "https://github.com/tiwariakshat47/DermaScan/",
  },
];
